module.exports = __webpack_public_path__ + "static/quiz4_question1-7352e85528b07fc840009c9eb7d11507.jpg";